import { take, put, race, select } from 'redux-saga/effects'
import { SUCCESS, FAILED } from 'crom-api-constants'
import _ from 'lodash'

import { error } from '../../../../../services/toastr'

import { INSERT_MEMBER_TO_GROUP_REQUEST, LOCALE_PREFIX } from '../constants'

import { insertMemberToGroupRequest, loadGroupMembers } from '../actions'
import { loadGroups } from '../../EntityStack/components/StackContent/components/GroupsContent/actions'

import { groupStackSelector, sessionIdSelector, groupMembersSelector } from '../selectors'

export default function* groupStackDropSaga(action) {
    const groupId = _.get(action, 'data.groupId', null)
    const memberId = _.get(action, 'data.memberId', null)

    const groupStack = yield select(groupStackSelector)
    const groupData = !_.isNil(groupStack) ? groupStack.get('groupData') : null
    const rows = _.get(groupData, 'rows', null)

    const group = yield select(groupMembersSelector, _.toString(groupId))
    const members = !_.isNil(group) ? group.get('members') : null
    const sessionId = yield select(sessionIdSelector)

    yield put(insertMemberToGroupRequest(groupId, memberId, sessionId, members + 1))

    const result = yield race({
        success: take(`${INSERT_MEMBER_TO_GROUP_REQUEST(groupId)}_${SUCCESS}`),
        failed: take(`${INSERT_MEMBER_TO_GROUP_REQUEST(groupId)}_${FAILED}`),
    })

    if (!result.failed) {
        yield put(loadGroupMembers(groupId, 0, rows))
    } else {
        error({
            id: `${LOCALE_PREFIX}.insertError`,
        })
    }

    yield put(loadGroups())
    return null
}
